import React from "react";
import "./StaticPage.css";

export default function PrivacyPolicy() {
  return (
    <div className="static-page">
      <div className="static-container">
        <span className="section-label">Legal</span>
        <h1>Privacy Policy</h1>
        <p className="static-intro">
          At PureJar (a venture of Neoteric Roots Private Limited), we respect your privacy and are
          committed to protecting your personal information. This policy explains what we collect,
          why, and how we keep it safe. Last updated: July 2026.
        </p>

        <section>
          <h2>Information We Collect</h2>
          <p>When you shop with us or create an account, we may collect:</p>
          <ul>
            <li><strong>Contact details</strong> — name, email address, phone number, and delivery address.</li>
            <li><strong>Order information</strong> — products purchased, order history, and payment confirmation (we never store your card details).</li>
            <li><strong>Account information</strong> — login credentials managed securely through Firebase Authentication.</li>
            <li><strong>Usage data</strong> — how you interact with our website, to help us improve your experience.</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <ul>
            <li>To process and deliver your orders, and send order confirmations and shipping updates.</li>
            <li>To respond to your questions and provide customer support.</li>
            <li>To send you a welcome email and, if you opt in, occasional updates about our products.</li>
            <li>To improve our website, products, and services.</li>
          </ul>
        </section>

        <section>
          <h2>Payment Security</h2>
          <p>
            All payments are processed securely through Razorpay, a PCI-DSS compliant payment gateway.
            PureJar does not see, store, or handle your card, UPI, or banking details directly.
          </p>
        </section>

        <section>
          <h2>Sharing Your Information</h2>
          <p>We only share your information with trusted partners who help us run our business:</p>
          <ul>
            <li><strong>Shiprocket and courier partners</strong> — to deliver your orders.</li>
            <li><strong>Razorpay</strong> — to process payments.</li>
            <li><strong>Email service providers</strong> — to send transactional emails.</li>
          </ul>
          <p>We never sell your personal information to third parties.</p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>
            You can access, update, or request deletion of your personal information at any time.
            To do so, email us at <a href="mailto:wecare@purejar.in">wecare@purejar.in</a> and we'll help you.
          </p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            We use minimal cookies and local storage to keep your cart and login session working smoothly.
            These are essential for the website to function.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            Questions about your privacy? Reach out to us at <a href="mailto:wecare@purejar.in">wecare@purejar.in</a> or
            write to: Neoteric Roots Private Limited, Rampur Road, Dewalchaur, Haldwani, Nainital, Uttarakhand — 263139.
          </p>
        </section>
      </div>
    </div>
  );
}
